import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import TournamentTablesNavigator from "../../../navigation/TournamentTablesNavigator";
import styles from "./tournamentTables.module.css";

const TournmentTables = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/tournament-tables/show-all-tournaments">
              عرض جميع البطولات
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <TournamentTablesNavigator />
    </div>
  );
};

export default TournmentTables;
